import type { OrganizationWithMembersCount } from '@cmoh/shared'

/**
 * Organization status information
 */
export interface OrganizationStatus {
  isActive: boolean
  text: string
  variant: 'default' | 'secondary'
}

/**
 * Members count information
 */
export interface MembersCountInfo {
  count: number
  text: string
  variant: 'default' | 'secondary'
}

/**
 * Gets the status information for an organization
 */
export function getOrganizationStatus(
  organization: OrganizationWithMembersCount,
  translations: {
    active: string
    inactive: string
  },
): OrganizationStatus {
  const isActive = !organization.deletedAt
  return {
    isActive,
    text: isActive ? translations.active : translations.inactive,
    variant: isActive ? 'default' : 'secondary',
  }
}

/**
 * Gets the members count information for an organization
 */
export function getMembersCountInfo(
  count: number,
  translations: {
    member: string
    members: string
  },
): MembersCountInfo {
  const actualCount = count || 0
  const translation = actualCount === 1 ? translations.member : translations.members
  const text = `${actualCount} ${translation}`

  return {
    count: actualCount,
    text,
    variant: actualCount > 0 ? 'default' : 'secondary',
  }
}
